export function fmt(val: number | null): string {
  if (val === null) return '—'
  if (val % 1 === 0) return String(val)
  return parseFloat(val.toFixed(4)).toString()
}

export function fmtPrice(val: number | null): string {
  if (val === null) return '—'
  const stripped = parseFloat(val.toFixed(5)).toString()
  const [int, dec = ''] = stripped.split('.')
  return `€ ${int}.${dec.padEnd(2, '0')}`
}

export function fmtPriceBasis(price: number | null, basisQty: number | null, basisUom: string | null): string {
  if (price === null) return '—'
  const base = fmtPrice(price)
  if (!basisUom) return base
  if (basisQty && basisQty > 1) return `${base}/${Math.round(basisQty)} ${basisUom}`
  return `${base}/${basisUom}`
}
